import { XyoWorldMapStyle } from '../../lib'
import { PlayMapSettings } from './Context'
import Name from './Name'

const PlayMapDefaultSettings: PlayMapSettings = {}

const AppSettingDefault = {
  [Name.DarkMode]: true,
  [Name.DeveloperMode]: false,
  [Name.InfuraAsDefault]: false,
  [Name.MapStyle]: XyoWorldMapStyle.Light,
  [Name.PlayMapSettings]: PlayMapDefaultSettings,
  [Name.RequestLocation]: true,
}

export default AppSettingDefault
